<div class="tab-details container">
    <div class="row">
        <div class="col-12 mb-3">
            <mat-label>
                <p>Compute Configuration *</p>
                <h4>{{computeConfig?.computeDetails ? computeConfig?.computeDetails : '-'}}</h4>
            </mat-label>
        </div>
    </div>
</div>